import Keycloak from "keycloak-js"
import type { KeycloakInstance } from "keycloak-js"
import type { KeycloakConfig } from "../config/keycloak"

let keycloakInstance: KeycloakInstance | null = null

type KeycloakEventHandlers = {
  onAuthSuccess?: KeycloakInstance["onAuthSuccess"]
  onAuthRefreshSuccess?: KeycloakInstance["onAuthRefreshSuccess"]
  onAuthLogout?: KeycloakInstance["onAuthLogout"]
  onTokenExpired?: KeycloakInstance["onTokenExpired"]
}

export const getKeycloakInstance = (config: KeycloakConfig): KeycloakInstance => {
  if (!keycloakInstance) {
    keycloakInstance = new Keycloak({
      url: config.url,
      realm: config.realm,
      clientId: config.clientId,
    })
  }
  return keycloakInstance
}

export const bindKeycloakEvents = (instance: KeycloakInstance, handlers: KeycloakEventHandlers) => {
  instance.onAuthSuccess = handlers.onAuthSuccess
  instance.onAuthRefreshSuccess = handlers.onAuthRefreshSuccess
  instance.onAuthLogout = handlers.onAuthLogout
  instance.onTokenExpired = handlers.onTokenExpired

  return () => {
    instance.onAuthSuccess = undefined
    instance.onAuthRefreshSuccess = undefined
    instance.onAuthLogout = undefined
    instance.onTokenExpired = undefined
  }
}
